import { useEffect, useState } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Investors,
} from "../../../../app/slices/investorsSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineUserGroup, HiOutlineDocumentText } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const InvestorsForm = () => {
  const _Investors = useSelector((state) => state.investors.investor);
  const _SearchBody = useSelector((state) => state.investors.searchBody);

  const isAdd = _Investors.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      ..._Investors.form,
    },
  });

  const [saving, setSaving] = useState(false);

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      if (isAdd) {
        await dispatch(
          Investors.create({
            name: data.name,
            note: data.note,
          })
        );
      } else {
        await dispatch(
          Investors.update(
            data.id,
            {
              name: data.name,
              note: data.note,
            },
            _SearchBody
          )
        );
      }
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    reset({
      ..._Investors.form,
      province: {
        id: _Investors.form.province_id,
        name: _Investors.form.province_name,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_Investors.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_Investors.dialog}
      onClose={handleClose}
      icon={<HiOutlineUserGroup />}
      title={isAdd ? "إضافة ممول جديد" : "تعديل بيانات الممول"}
      subtitle={
        isAdd
          ? "أدخل معلومات الممول لإضافته الى القائمة"
          : "قم بتحديث معلومات الممول ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={saving}
    >
      <SectionCard icon={<HiOutlineDocumentText />} title="معلومات الممول">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                multiline
                rows={2}
                size="small"
                label="ملاحظات"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default InvestorsForm;
